var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.getSelectedRows()}}},[_vm._v("Get Selected Rows")]),_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"width":"500px","height":"500px"},attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"rowSelection":"multiple"},on:{"grid-ready":_vm.onGridReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }